import _extends from '@babel/runtime/helpers/extends';
import React__default from 'react';
import styled, { css } from 'styled-components';
import { i as isMobile } from '../../theme/style-mixins/isMobile/isMobile-CGsYoba7.js';

const StyledCell = /*#__PURE__*/styled.td.withConfig({
  componentId: "sc-storm-ui-30063520__sc-1ljfili-0"
})(["flex:3 0;background:", ";color:", ";font-size:", ";font-weight:", ";padding-top:", ";padding-right:", ";padding-bottom:", ";padding-left:", ";text-align:start;vertical-align:top;", " :last-child{padding-right:", ";}"], ({
  theme
}) => theme.table.data.bg, ({
  theme
}) => theme.table.data.color, ({
  theme
}) => theme.table.data.fontSize, ({
  theme
}) => theme.table.data.fontWeight, ({
  theme
}) => theme.table.data.paddingTop, ({
  theme
}) => theme.table.data.paddingRight, ({
  theme
}) => theme.table.data.paddingBottom, ({
  theme
}) => theme.table.data.paddingLeft, isMobile(css(["flex:1 0;font-size:", ";"], ({
  theme
}) => theme.table.mobile.data.fontSize)), ({
  theme
}) => theme.table.data.paddingRight);
const ValueCell = ({
  children,
  ...rest
}) => /*#__PURE__*/React__default.createElement(StyledCell, _extends({
  role: "cell"
}, rest), children);

export { ValueCell as V };
//# sourceMappingURL=ValueCell-DiU6N78Q.js.map
